export const FontAwesomeIcons = {
  CabinetFilingRegular: 'fa-regular fa-cabinet-filing',
  PenToSquare: 'pen-to-square',
  Plus: 'plus',
  PaperclipRegular: 'fa-regular fa-paperclip',
  Trash: 'trash',
  Folder: 'folder',
  Spinner: 'spinner',
  Eye: 'eye',
  Copy: 'copy',
  Warning: 'fa-triangle-exclamation',
  Shield: 'shield'
};
